import {
    SingleSelectOptionV2,
    MultiSelectOptionV2,
    ExpandableRowV2,
    IOptionV2,
    IGroupOptionV2
} from "components/v2/components/common/selects"

interface ISelectMenuV2Props {
    options: (IOptionV2 | IGroupOptionV2)[]
    mode: "single" | "multiple"
    selectedKeys: (string | number)[]
    handleSelectOption: (option: string | number) => void
    isSearching: boolean
}

const SelectMenuV2 = ({ options, mode, selectedKeys, handleSelectOption, isSearching }: ISelectMenuV2Props) => {
    const renderOptions = (opts: (IOptionV2 | IGroupOptionV2)[], level = 0) => {
        return opts.map((option) =>
            "groupName" in option ? (
                <div key={option.groupName} className={`pl-${level * 4}`}>
                    <ExpandableRowV2 header={option.groupName} isSearching={isSearching}>
                        {renderOptions(option.options, level + 1)}
                    </ExpandableRowV2>
                </div>
            ) : mode === "multiple" ? (
                <div key={option.id} className={`pl-${level * 4}`}>
                    <MultiSelectOptionV2
                        option={option}
                        isSelected={selectedKeys.includes(option.id)}
                        handleSelectOption={handleSelectOption}
                    />
                </div>
            ) : (
                <div key={option.id} className={`pl-${level * 4}`}>
                    <SingleSelectOptionV2 option={option} handleSelectOption={handleSelectOption} />
                </div>
            )
        )
    }

    return <>{renderOptions(options)}</>
}

export default SelectMenuV2
